<template>
    <div class="loading" v-show="isLoadingShow"></div>
</template>

<script>
    import {mapGetters} from 'vuex';

    export default {
        name: '',
        computed: {
            ...mapGetters(['isLoadingShow'])
        },
        methods: {
            event_touchmove () {
               return false;
            }
        }
    }
</script>

<style lang="scss" scoped>
    // loading状态公共样式
    @-webkit-keyframes loading {100%{-webkit-transform: rotate(0deg) translateZ(0);}}
    @keyframes loading {100%{transform: rotate(0deg) translateZ(0);}}

    .loading {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        z-index: 20;
        /*background-color: rgba(255, 255, 255, 0.8);*/
        &:after {
            content: '';
            width: 0.45rem;
            height: 0.45rem;
            border: 0.06rem solid #1A191E;
            border-right-color: transparent;
            position: absolute;
            top: 50%;
            left: 50%;
            margin: -0.3rem;
            z-index: 500;
            pointer-events: none;

            -webkit-border-radius: 50%;
            border-radius: 50%;

            -webkit-transform: rotate(-360deg) translateZ(0);
            transform: rotate(-360deg) translateZ(0);

            -webkit-animation: loading 0.5s linear 0s infinite forwards;
            animation: loading 0.5s linear 0s infinite forwards;
        }

    }
</style>



// WEBPACK FOOTER //
// src/components/MLoading/index.vue